<template>
  <div class="cube-card-list">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'CardList',
  componentName: 'CardList',
  provide() {
    return {
      cardlist: this
    }
  },
  props: {
    accordion: Boolean,
    value: {
      type: [Array, String, Number],
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeNames: [].concat(this.value)
    }
  },
  watch: {
    value(value) {
      this.activeNames = [].concat(value)
    }
  },
  methods: {
    setActiveNames(activeNames) {
      activeNames = [].concat(activeNames)
      const value = this.accordion ? activeNames[0] : activeNames
      this.activeNames = activeNames
      this.$emit('input', value)
      this.$emit('change', value)
    },
    handleItemClick(item) {
      if (this.accordion) {
        this.setActiveNames(
          (this.activeNames[0] || this.activeNames[0] === 0) &&
            this.activeNames[0] === item.name
            ? ''
            : item.name
        )
      } else {
        const activeNames = this.activeNames.slice(0)
        const index = activeNames.indexOf(item.name)
        if (index > -1) {
          activeNames.splice(index, 1)
        } else {
          activeNames.push(item.name)
        }
        this.setActiveNames(activeNames)
      }
    }
  }
}
</script>
